import React from "react";
import MastakashApp from "../../assets/img/hero.png";

const Interoperability = () => {
  return (
    <section className="w-full py-20 bg-gray-50">
      <div className="container mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

        {/* Text Section */}
        <div>
          <h1 className="text-4xl lg:text-5xl font-bold leading-tight text-gray-900 mb-6">
            Powering Financial <span className="text-orange-500">Interoperability</span> for Communities and Institutions
          </h1>

          <p className="text-gray-700 text-lg leading-relaxed mb-4">
            MastaKash is creating a unified financial layer that connects individuals, groups, 
            cooperatives, and institutions across different financial ecosystems. 
            Whether you're sending money, paying contributions, managing group accounts, or 
            linking to banks—MastaKash ensures everything works seamlessly together.
          </p>

          <p className="text-gray-700 text-lg leading-relaxed mb-6">
            We eliminate fragmentation between community finance systems, banks, 
            and digital payment channels—allowing people and organisations to interact 
            with any financial service without switching platforms or infrastructure.
          </p>

          <a
            href="https://appstore.roshtech.co.ke/apps/edad31f8-921e-4cb0-92dc-d7cbabd0bcde"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="bg-purple-700 hover:bg-purple-800 transition text-white text-lg px-8 py-3 rounded-full shadow-lg">
              Download MastaKash App
            </button>
          </a>
        </div>

        {/* Image Section */}
        <div className="flex justify-center">
          <img
            src={MastakashApp}
            alt="MastaKash App"
            className="w-full max-w-md drop-shadow-xl"
          />
        </div>

      </div>
    </section>
  );
};

export default Interoperability;
